import { useNavigate } from "react-router";
import DashboardCard from '../common/DashboardCard';
import { Box, Typography, Button, Stack } from '@mui/material';
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';
import SettingsIcon from '@mui/icons-material/Settings';
import ViewListIcon from '@mui/icons-material/ViewList';

function Scenarios(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const navigate = useNavigate();

    return (
        <DashboardCard
            title="Scenarios"
            icon={<FormatListNumberedRtlIcon />}
            actions={
                <Stack direction="row" spacing={2}>
                    {dashboardInfo.lastDraftScenario && (
                        <Button
                            startIcon={<SettingsIcon />}
                            onClick={() => {
                                navigate("/plan/scenario/configuration", {
                                    state: {
                                        fleetScenarioUuid: dashboardInfo.lastDraftScenario?.uuid,
                                    },
                                });
                            }}
                        >
                            Configure
                        </Button>
                    )}
                    <Button
                        startIcon={<ViewListIcon />}
                        onClick={() => navigate("/plan/insight/fleet")}
                    >
                        View All Scenarios
                    </Button>
                </Stack>
            }
        >
            <Stack spacing={2}>
                {dashboardInfo.lastRunScenario && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" color="text.secondary">
                            Last Run Scenario:
                        </Typography>
                        <Typography variant="body1">
                            {dashboardInfo.lastRunScenario.fleetName} / Scenario {dashboardInfo.lastRunScenario.fleetScenarioNumber}
                        </Typography>
                    </Box>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body1" color="text.secondary">
                        Latest Draft Scenario:
                    </Typography>
                    <Typography variant="body1">
                        {dashboardInfo.lastDraftScenario?.fleetName} / Scenario {dashboardInfo.lastDraftScenario?.fleetScenarioNumber}
                    </Typography>
                </Box>
            </Stack>
        </DashboardCard>
    );
}

export default Scenarios;
